var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-about-page"},[_c('div',{staticClass:"about-page"},[_c('stories-partial'),_c('leadership-partial'),_c('team-partial')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }